import RestClient from '../../config/rest-client';

export async function getCard(id) {
  try {
    const data = await RestClient.findOne('flashcards/view', id);
    return data;
  } catch (error) {
    return {
      category: null,
      questions: []
    }
  }
}

export async function downloadAnki(id) {
  try {
    const data = await RestClient.findOne('flashcards/export/anki', id);
    return data;
  } catch (error) {
    return {}
  }
}
